import React, { useRef, useState, useEffect, useMemo } from "react";
import { X, Minimize2, Maximize2, GripVertical } from "lucide-react";
import { usePopup } from "../../hooks/usePopup";
// import { DraggablePopupContent } from "../../containers/LiveTrack/LiveMapcomponent";
import InteractiveMap, { Marker } from "react-map-gl";
import { Row } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as LiveTrackone } from "../../assets/livetracking/livetrackone.svg";
import { ReactComponent as LiveTrackFour } from "../../assets/livetracking/livetrackfour.svg";
import { ReactComponent as VideoIcon } from "../../assets/images/Video.svg";
import { ReactComponent as Videoon } from "../../assets/images/Video-On.svg";
import { ReactComponent as Info } from "../../assets/images/Info.svg";
import { ReactComponent as Infoon } from "../../assets/images/Info-On.svg";
import { ReactComponent as SpeedIcon } from "../../assets/images/speed (2).svg";
import { ReactComponent as SignalIcon } from "../../assets/images/Signals-2.svg";
import { ReactComponent as LockIcon } from "../../assets/images/locked.svg";
import { ReactComponent as UnLockIcon } from "../../assets/images/unlocked.svg";
import { ReactComponent as Batteryicon } from "../../assets/images/gg_battery.svg";
import { ReactComponent as LowBatteryicon } from "../../assets/images/low-bt.svg";
import { ReactComponent as MovingVehicle } from "../../assets/images/MovingVehicle.svg";
import { ReactComponent as StationaryVehicle } from "../../assets/images/StationaryVehicle.svg";
import { ReactComponent as PinIcon } from "../../../src/assets/livetracking/pinIcon.svg";
import { ReactComponent as PinIconOne } from "../../../src/assets/livetracking/PinIconone.svg";
import styled from "styled-components";
import {
  setIsDeviceInfoActive,
  setIsDeviceTrackingActive,
  setIsUnlockConfirmVisible,
  setOpen,
  setSelectedId,
  setUnlockConfirmDevice,
} from "../../Redux/AuthSlice";

const MAPBOX_TOKEN =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";

const Newbox = styled.div`
  .signal-icons {
    display: flex;
    gap: 6px;
  }

  .signal-item {
    position: relative;
    cursor: pointer;
  }

  .signal-tooltip {
    position: absolute;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.85);
    color: #fff;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease;
  }

  .signal-item:hover .signal-tooltip {
    opacity: 1;
  }
  .marker-wrapper {
    position: relative;
    display: inline-block;
  }

  /* Wave effect ONLY when isHovered = true */
  .vehicle-icon.wave-object {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
  }

  /* Pseudo-elements for wave rings */
  .marker-wrapper.wave-active .wave-object::before,
  .marker-wrapper.wave-active .wave-object::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    border-radius: 50%;
    background: radial-gradient(
      rgba(255, 0, 0, 0.6) 0%,
      rgba(255, 0, 0, 0.25) 60%,
      rgba(255, 0, 0, 0) 100%
    );
    opacity: 0;
    pointer-events: none;
    /* Force hardware acceleration */
    will-change: transform, opacity;
    backface-visibility: hidden;
  }

  /* First wave */
  .marker-wrapper.wave-active .wave-object::before {
    animation: waveGlow 3s ease-out infinite;
    animation-fill-mode: forwards;
  }

  /* Second wave with delay */
  .marker-wrapper.wave-active .wave-object::after {
    animation: waveGlow 3s ease-out infinite 1.5s;
    animation-fill-mode: forwards;
  }

  @keyframes waveGlow {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.9;
    }
    50% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0.5;
    }
    100% {
      transform: translate(-50%, -50%) scale(4);
      opacity: 0;
    }
  }

  .marker-wrapper.wave-active .wave-object::before,
  .marker-wrapper.wave-active .wave-object::after {
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .marker-wrapper {
    overflow: visible !important;
  }

  .vehicle-icon.wave-object {
    overflow: visible !important;
  }

  .marker-wrapper.wave-active svg,
  .marker-wrapper.wave-active img {
    position: relative;
    z-index: 10;
  }

  body {
    overflow: hidden; /* prevent the whole page from scrolling */
  }
  .mapboxgl-popup-content {
    padding: 0 !important;
    background: #fff;
    border-radius: 20px !important; /* applies to all corners */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    overflow: hidden; /* ensure the radius clips content properly */
  }

  .mapboxgl-popup-tip {
    border-top-color: #e6faf0; /* matches your popup header background */
    width: 15px;
    height: 15px;
  }

  .mapboxgl-popup {
    z-index: 10 !important; /* very high value to be on top */
  }
  .body-content {
    height: 220px;
    width: 100%;
    padding: 12px 14px;
    border-top: 1px solid #eee;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: #fff;
  }
  .mapbox-marker {
    position: absolute;
    z-index: 10; /* lower than card */
  }
  .zoom_container {
    position: absolute;
    bottom: 100px;
    right: 10px;
    zindex: 1000;
    display: flex;
    flexdirection: row;
    gap: 10px;
  }
  .zoom_Body {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #ccc;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
  .ZoomOut_Btn,
  .ZoomIn_Btn {
    width: 40px;
    height: 40px;
    border: none;
    background: #fff;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    transition: border 0.2s, background 0.2s;
    outline: none; /* removes default focus border */
  }

  .ZoomOut_Btn:hover,
  .ZoomOut_Btn:focus {
    border: 1px solid #fff; /* hover/focus border color */
    background: #f9f9f9;
  }

  .ZoomIn_Btn {
    border-bottom: 1px solid #ccc;
  }

  .ZoomIn_Btn:hover,
  .ZoomIn_Btn:focus {
    border-bottom: 1px solid #fff; /* hover/focus border color */
    background: #f9f9f9;
  }
  .unit-details-popup {
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    cursor: text;
  }
  .vehicle-marker-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  /* LABEL */
  .vehicle-label-bubble {
    position: absolute;
    bottom: -32px;
    left: -50%; /* place below marker */
    background: #fff;
    padding: 4px 12px;
    border-radius: 16px;
    border: 2px solid #d9d9d9; /* default */
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); /* Ant Design shadow */
  }

  /* --- ARROW --- */
  .vehicle-label-bubble .bubble-arrow {
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid #d9d9d9; /* arrow border color */
  }

  /* Inner white fill (optional for perfect AntD style) */
  .vehicle-label-bubble .bubble-arrow::after {
    content: "";
    position: absolute;
    top: 2px;
    left: -5px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 7px solid #fff;
  }

  /* --- STATUS COLORS --- */
  .moving {
    border-color: #3cb043 !important;
  }
  .moving .bubble-arrow {
    border-bottom-color: #3cb043 !important;
  }

  .idling {
    border-color: #ffa500 !important;
  }
  .idling .bubble-arrow {
    border-bottom-color: #ffa500 !important;
  }

  .stationary {
    border-color: #9e9e9e !important;
  }
  .stationary .bubble-arrow {
    border-bottom-color: #9e9e9e !important;
  }
  @keyframes vehicle-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(52, 199, 89, 0.7);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 0 0 20px rgba(52, 199, 89, 0);
      transform: scale(1.1);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(52, 199, 89, 0);
      transform: scale(1);
    }
  }

  .vehicle-marker-highlighted {
    animation: vehicle-pulse 1.5s ease-out;
  }

  .vehicle-marker-wrapper,
  .marker-wrapper {
    position: relative;
    transition: transform 0.3s ease;
  }

  .vehicle-marker-wrapper.highlighted,
  .marker-wrapper.highlighted {
    z-index: 1000;
  }
`;

const DraggablePopup = ({
  LiveVehicleDetailMap,
  visibleFGUIDs,
  selectedFGUIDs = [],
  MonitorDetails,
  statustime,
}) => {
  const {
    isOpen,
    isMinimized,
    position,
    popupData,
    closePopup,
    toggleMinimize,
    setPosition,
    updatePopupData,
  } = usePopup();

  const DevicerenderInfoPanel = useSelector(
    (state) => state?.authTracking?.DevicerenderinfoPanel
  );
  const isDeviceInfoActive = useSelector(
    (state) => state?.authTracking?.isDeviceInfoActive
  );
  const DeviceToRender = useSelector(
    (state) => state?.authTracking?.DeviceTorender
  );
  const isDeviceTrackingActive = useSelector(
    (state) => state?.authTracking?.isDeviceTrackingActive
  );
  const selectedId = useSelector((state) => state?.authTracking?.selectedId);
  const livemapLocationName = useSelector(
    (state) => state?.authTracking?.livemapLocationName
  );
  const isUnlockConfirmVisible = useSelector(
    (state) => state?.authTracking?.isUnlockConfirmVisible
  );

  console.log("popupData", popupData, isOpen);

  const popupRef = useRef(null);
  const isDraggingRef = useRef(false);
  const dragOffsetRef = useRef({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    e.stopPropagation();
    if (e.target.closest(".popup-header")) {
      setIsDragging(true);
      const rect = popupRef.current.getBoundingClientRect();
      setDragOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      });
    }
  };

  const handleMouseMove = (e) => {
    e.stopPropagation();
    if (isDragging) {
      setPosition({
        x: e.clientX - dragOffset.x,
        y: e.clientY - dragOffset.y,
      });
    }
  };

  const handleMouseUp = (e) => {
    e.stopPropagation();
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [isDragging, dragOffset]);

  console.log(isUnlockConfirmVisible, selectedId, "checkmedddss");
  const dispatch = useDispatch();

  //   const DeviceToRender = useMemo(() => {
  //     const baseArray = Array.isArray(LiveVehicleDetailMap)
  //       ? LiveVehicleDetailMap
  //       : LiveVehicleDetailMap
  //         ? [LiveVehicleDetailMap]
  //         : [];
  //   console.log(baseArray , "baseArraybaseArray")

  //     const filtered = baseArray
  //       .filter((item) => item.FAssetTypeID === 3701)
  //       .filter((item) => {
  //         if (visibleFGUIDs.length > 0) {
  //           return visibleFGUIDs.includes(item.FAssetGUID) ||
  //             visibleFGUIDs.includes(item.FGUID) ||
  //             visibleFGUIDs.includes(item.FVehicleGUID);
  //         }

  //         return selectedFGUIDs.length === 0 && null;
  //       })
  //       .map((item) => {
  //         let matchingMonitor = MonitorDetails.find((monitor) => {
  //           // Match by ID
  //           if (monitor.ID && item.FAssetID && monitor.ID === item.FAssetID) {
  //             return true;
  //           }

  //           return false;
  //         });

  //         if (matchingMonitor &&
  //           matchingMonitor.Lat &&
  //           matchingMonitor.Lon &&
  //           matchingMonitor.Lat !== 0 &&
  //           matchingMonitor.Lon !== 0) {

  //           return {
  //             ...item,
  //             FLatitude: matchingMonitor.Lat,
  //             FLongitude: matchingMonitor.Lon,
  //             FSpeed: matchingMonitor.Speed || 0,
  //             FACC: matchingMonitor.Vehicle?.ACC || 0,
  //             FOnline: matchingMonitor.RT ? 1 : 0,
  //             FBattery: matchingMonitor.Lock?.Bat,
  //             FLockStatus: matchingMonitor.Lock?.LS,
  //           };
  //         }

  //         console.warn(`No match for device ${item.FAssetID}`);
  //         return item;
  //       });

  //     return filtered;
  //   }, [LiveVehicleDetailMap, selectedFGUIDs, visibleFGUIDs, MonitorDetails]);

  console.log(DeviceToRender, "DeviceToRenderDeviceToRender");
  //    const DevicerenderInfoPanel = (device) => {
  //     // Speed
  //     const speed = Number(device?.FSpeed) || 0;
  //     const isOnline = device?.FOnline === 1; // 1 = online, 0 = offline
  //     const engine = Number(device?.FACC); // 1 = open, 0 = close
  //     let statusText;
  //     let statusColor;
  //     // Duration since last GPS

  //     let durationText = "";
  //     let days = 0,
  //       hours = 0,
  //       minutes = 0;

  //     if (statustime?.RGTime) {
  //       const gpsTime = dayjs.utc(statustime.RGTime);
  //       const now = dayjs.utc();
  //       const diffInMillis = now.diff(gpsTime);
  //       days = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
  //       hours = Math.floor(
  //         (diffInMillis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //       );
  //       minutes = Math.floor((diffInMillis % (1000 * 60 * 60)) / (1000 * 60));

  //       if (days > 0) durationText += `${days}d `;
  //       if (hours > 0) durationText += `${hours}h `;
  //       if (minutes > 0) durationText += `${minutes}min`;
  //       durationText = durationText.trim();
  //     }

  //     // Run status
  //     if (!isOnline) {
  //       statusText = "Offline";
  //       statusColor = "#FF3B30"; // red (example)
  //     } else if (speed > 0) {
  //       statusText = "Moving";
  //       statusColor = "#34C759"; // green
  //     } else if (speed === 0 && engine === 1) {
  //       statusText = "Idle";
  //       statusColor = "#FF9500"; // orange
  //     } else if (speed === 0 && engine === 0) {
  //       statusText = "Stationary";
  //       statusColor = "#C7C7CC"; // gray
  //     } else {
  //       statusText = "Unknown";
  //       statusColor = "#000000";
  //     }
  //     if (speed === 0 && engine === 0 && isOnline) {
  //       statusText = "Parking";
  //       statusColor = "#C7C7CC"; // gray
  //     }
  //     const statusWithTime = durationText
  //       ? `${statusText} (${durationText})`
  //       : statusText;

  //     // Location
  //     const locationName = livemapLocationName ?? device?.FVehicleName ?? "--";

  //     // Backcover parsing
  //     let backCoverStatus = "Undefined";
  //     try {
  //       const desc = JSON.parse(device?.FExpandProto?.FDesc || "{}");
  //       if (desc?.fBackCover === 0) backCoverStatus = "Closed";
  //       else if (desc?.fBackCover === 1) backCoverStatus = "Open";
  //     } catch { }

  //     // GPS formatted time
  //     const gpsTime = device?.FGPSTime
  //       ? `${new Date(device.FGPSTime).toLocaleTimeString([], {
  //         hour: "2-digit",
  //         minute: "2-digit",
  //       })} • ${new Date(device.FGPSTime)
  //         .getDate()
  //         .toString()
  //         .padStart(2, "0")}-${(new Date(device.FGPSTime).getMonth() + 1)
  //           .toString()
  //           .padStart(2, "0")}-${new Date(device.FGPSTime).getFullYear()}`
  //       : "--";

  //     return (
  //       <Newbox>
  //         <div className="body-content">
  //           <Row label="Location" value={locationName} />
  //           <Row label="GPS Time" value={gpsTime} />
  //           <Row label="Run Status" value={"loading" ? "loading..." : statusWithTime ?? "--"} />
  //           <Row label="Mileage" value={`${device?.FMileage ?? "--"} Km`} />
  //           <Row
  //             label="Lat, Long"
  //             value={`${device?.FLatitude ?? "--"}, ${device?.FLongitude ?? "--"
  //               }`}
  //           />

  //           {/* Status section */}
  //           <div
  //             style={{
  //               display: "grid",
  //               gridTemplateColumns: "150px 1fr",
  //               marginBottom: 6,
  //             }}
  //           >
  //             <span style={{ fontSize: 13, color: "#333" }}>Status</span>
  //             <span
  //               style={{
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 gap: 4,
  //                 color: "#6B7280",
  //               }}
  //             >
  //               <div>
  //                 Lock Rope:{" "}
  //                 {device?.FLockRope === 1
  //                   ? "PullOut"
  //                   : device?.FLockRope === 0
  //                     ? "Insert"
  //                     : "Undefined"}
  //               </div>
  //               <div>
  //                 Lock State:{" "}
  //                 {device?.FLockStatus === 1
  //                   ? "Unlock"
  //                   : device?.FLockStatus === 0
  //                     ? "Lock"
  //                     : "Undefined"}
  //               </div>
  //               <div>Backcover: {backCoverStatus}</div>
  //               <div>LBS: {device?.FLocationType ?? "--"}</div>
  //             </span>
  //           </div>
  //         </div>
  //       </Newbox>
  //     );
  //   };

  const renderDeviceTrackingPanel = (device) => {
    const lat = device.FLatitude ? Number(device.FLatitude) : 0;
    const lng = device.FLongitude ? Number(device.FLongitude) : 0;
    if (isNaN(lat) || isNaN(lng)) return <div>No location available</div>;

    // You can adjust zoom/size as needed
    return (
      <div
        style={{
          padding: "0",
          height: 234,
          width: "100%",
          borderTop: "1px solid #eee",
        }}
      >
        <InteractiveMap
          latitude={lat}
          longitude={lng}
          zoom={15}
          width="100%"
          height={234}
          mapStyle="mapbox://styles/mapbox/streets-v11"
          mapboxApiAccessToken={MAPBOX_TOKEN}
          scrollZoom={true}
          dragPan={true}
          attributionControl={false}
        >
          <Marker latitude={lat} longitude={lng} anchor="bottom">
            <LiveTrackFour
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
              }}
            />
          </Marker>
        </InteractiveMap>
      </div>
    );
  };
  const open = useSelector((state) => state?.authTracking?.open);

  return (
    <>
      {open ? (
        <div
          ref={popupRef}
          style={{
            position: "fixed",
            left: `${position.x}px`,
            top: `${position.y}px`,
            zIndex: 999999999999,
            backgroundColor: "green",
          }}
          className="select-none"
          onMouseDown={handleMouseDown}
        >
          <div className="bg-white rounded-lg shadow-2xl border border-gray-300 w-96">
            <div
              className="popup-header "
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                overflowY: "scroll",
              }}
            >
              {DeviceToRender?.map((device, idx) => {
                console.log(device, "devicetotrender");
                return (
                  <React.Fragment key={device.FAssetGUID || idx}>
                    {!isUnlockConfirmVisible &&
                      selectedId &&
                      (selectedId === device.FAssetGUID ||
                        selectedId === device.FGUID) && (
                        <div
                          className="unit-details-popup"
                          style={{
                            userSelect: "text",
                          }}
                        >
                          {/* === HEADER === */}
                          <div
                            style={{
                              background: "#E6FAF0",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: " 5px 10px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 14,
                                    color: "#111",
                                  }}
                                >
                                  {device?.FAssetID}
                                  {""}({device?.FVehicleName})
                                </span>

                                {(() => {
                                  const speed = Number(device?.FSpeed);
                                  const engine = Number(device?.FACC); // 1 = open, 0 = close
                                  const isOnline = device?.FOnline === 1; // 1 = online, 0 = offline
                                  let statusText;
                                  let statusColor;

                                  if (!isOnline) {
                                    statusText = "Offline";
                                    statusColor = "#FF3B30"; // red (example)
                                  } else if (speed > 0) {
                                    statusText = "Moving";
                                    statusColor = "#34C759"; // green
                                  } else if (speed === 0 && engine === 1) {
                                    statusText = "Idle";
                                    statusColor = "#FF9500"; // orange
                                  } else if (speed === 0 && engine === 0) {
                                    statusText = "Stationary";
                                    statusColor = "#C7C7CC"; // gray
                                  } else {
                                    statusText = "Unknown";
                                    statusColor = "#000000";
                                  }
                                  return (
                                    <span
                                      style={{
                                        background: statusColor,
                                        color: "#fff",
                                        fontSize: 12,
                                        padding: "2px 8px",
                                        borderRadius: 16,
                                        fontWeight: 500,
                                      }}
                                    >
                                      {statusText}
                                    </span>
                                  );
                                })()}
                              </div>

                              {isDeviceTrackingActive ? (
                                <div>
                                  <span
                                    onClick={() => {
                                      console.log("pin clicked");
                                      dispatch(setOpen(!open));
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {open ? "amopend" : "amclosed"}
                                    {isDeviceInfoActive ? (
                                      <PinIcon
                                        style={{ width: 17, height: 15 }}
                                      />
                                    ) : (
                                      <PinIconOne
                                        style={{ width: 17, height: 15 }}
                                      />
                                    )}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "5px 10px",
                                }}
                              >
                                <span
                                  onClick={() => {
                                    dispatch(
                                      setIsDeviceInfoActive((prev) => !prev)
                                    );
                                    dispatch(setIsDeviceTrackingActive(false));
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {isDeviceInfoActive ? (
                                    <Infoon style={{ width: 30, height: 30 }} />
                                  ) : (
                                    <Info style={{ width: 30, height: 30 }} />
                                  )}
                                </span>

                                <span
                                  onClick={() => {
                                    dispatch(
                                      setIsDeviceTrackingActive((prev) => !prev)
                                    );
                                    setIsDeviceInfoActive(false);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {isDeviceTrackingActive ? (
                                    <Videoon
                                      style={{ width: 30, height: 30 }}
                                    />
                                  ) : (
                                    <VideoIcon
                                      style={{ width: 30, height: 30 }}
                                    />
                                  )}
                                </span>
                              </div>
                            </div>

                            {isDeviceInfoActive && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  padding: "4px 15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 4,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div className="signal-icons">
                                      <div className="signal-item">
                                        <SignalIcon
                                          value={device?.FGPSSignal || 0}
                                          type="gps"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <span
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 500,
                                      color: "#333",
                                    }}
                                  >
                                    Signal
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 4,
                                  }}
                                >
                                  {Number(device?.FBattery) > 20 ? (
                                    <Batteryicon
                                      style={{ width: 30, height: 30 }}
                                    />
                                  ) : (
                                    <LowBatteryicon
                                      style={{ width: 30, height: 30 }}
                                    />
                                  )}
                                  <span
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 500,
                                      color: "#333",
                                    }}
                                  >
                                    {device?.FBattery
                                      ? `${device.FBattery}%`
                                      : "--"}
                                  </span>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 4,
                                  }}
                                >
                                  <SpeedIcon
                                    style={{
                                      width: 30,
                                      height: 30,
                                      color: "#555",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 500,
                                      color: "#333",
                                    }}
                                  >
                                    {Number(device?.FSpeed) || 0} km/h
                                  </span>
                                </div>

                                <div
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent map click from closing popup

                                    if (device?.FLockStatus === 0) {
                                      dispatch(setUnlockConfirmDevice(device));
                                      setIsUnlockConfirmVisible(true);
                                      dispatch(setSelectedId(null));
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 4,
                                    cursor:
                                      device?.FLockStatus === 0
                                        ? "pointer"
                                        : "default", // only show pointer when clickable
                                    opacity:
                                      device?.FLockStatus === 1 ? 0.5 : 1, // optional: grey out unlocked icon
                                  }}
                                >
                                  {device?.FLockStatus === 1 ? (
                                    <UnLockIcon
                                      style={{ width: 30, height: 30 }}
                                    />
                                  ) : (
                                    <LockIcon
                                      style={{ width: 30, height: 30 }}
                                    />
                                  )}
                                  <span
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 500,
                                      color: "#333",
                                    }}
                                  >
                                    {device?.FLockStatus === 1
                                      ? "Unlocked"
                                      : device?.FLockStatus === 0
                                      ? "Locked"
                                      : "Undefined"}
                                  </span>
                                </div>
                              </div>
                            )}

                            {isDeviceTrackingActive && (
                              <div
                                style={{
                                  fontSize: 13,
                                  fontWeight: 500,
                                  color: "#333",
                                  padding: " 4px 15px",
                                }}
                              >
                                <strong>Location: </strong>{" "}
                                {livemapLocationName ?? "Loading location..."}
                              </div>
                            )}
                          </div>

                          {isDeviceTrackingActive
                            ? renderDeviceTrackingPanel(device)
                            : DevicerenderInfoPanel(device)}
                        </div>
                      )}
                  </React.Fragment>
                );
              })}
            </div>

            {/* <DraggablePopupContent /> */}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DraggablePopup;
